import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SimpleAgencyCouriersQueryVariables = Types.Exact<{
  agencyId: Types.Scalars['ID'];
  date?: Types.InputMaybe<Types.Scalars['Date']>;
  courierFiltering?: Types.InputMaybe<Types.CourierFiltering>;
}>;


export type SimpleAgencyCouriersQuery = { __typename?: 'Query', CouriersByAgency: Array<{ __typename?: 'Courier', courierId: number, indicative?: string | null }> };


export const SimpleAgencyCouriersDocument = gql`
    query SimpleAgencyCouriers($agencyId: ID!, $date: Date, $courierFiltering: CourierFiltering) {
  CouriersByAgency(
    agencyId: $agencyId
    date: $date
    courierFiltering: $courierFiltering
  ) {
    courierId
    indicative
  }
}
    `;

/**
 * __useSimpleAgencyCouriersQuery__
 *
 * To run a query within a React component, call `useSimpleAgencyCouriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimpleAgencyCouriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimpleAgencyCouriersQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      date: // value for 'date'
 *      courierFiltering: // value for 'courierFiltering'
 *   },
 * });
 */
export function useSimpleAgencyCouriersQuery(baseOptions: Apollo.QueryHookOptions<SimpleAgencyCouriersQuery, SimpleAgencyCouriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SimpleAgencyCouriersQuery, SimpleAgencyCouriersQueryVariables>(SimpleAgencyCouriersDocument, options);
      }
export function useSimpleAgencyCouriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SimpleAgencyCouriersQuery, SimpleAgencyCouriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SimpleAgencyCouriersQuery, SimpleAgencyCouriersQueryVariables>(SimpleAgencyCouriersDocument, options);
        }
export type SimpleAgencyCouriersQueryHookResult = ReturnType<typeof useSimpleAgencyCouriersQuery>;
export type SimpleAgencyCouriersLazyQueryHookResult = ReturnType<typeof useSimpleAgencyCouriersLazyQuery>;
export type SimpleAgencyCouriersQueryResult = Apollo.QueryResult<SimpleAgencyCouriersQuery, SimpleAgencyCouriersQueryVariables>;